export default function(args){
    if(args === null || args === undefined) return 0;
    if(Array.isArray(args)) return args.length;
    if(typeof args === "string"){
        return args.length;
    }
    return String(args).length;
}
